import styled from "styled-components";
import {BaseButton, buttonStyles} from "./index";

export const SecondaryButton = styled(BaseButton)`
	${({theme}) => buttonStyles(theme.button.secondary)}
`;
